import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "@/pages/admin/Layout";
import Login from "@/pages/admin/Login";
import Protected from "@/pages/admin/Protected";

// Final simple operator hub (5 tabs)
import Products from "@/pages/admin/Products";
import Proof from "@/pages/admin/Proof";
import Homepage from "@/pages/admin/Homepage";
import Contact from "@/pages/admin/Contact";
import Settings from "@/pages/admin/Settings";
import Inquiries from "@/pages/admin/Inquiries";
import Categories from "@/pages/admin/Categories";
import Media from "@/pages/admin/Media";
import Marketing from "@/pages/admin/Marketing";
import Drops from "@/pages/admin/Drops";
import Referrals from "@/pages/admin/Referrals";

// Secondary Visual Editor (kept only, hit via "Edit on Site" button)
import VisualEditor from "@/pages/admin/VisualEditor";

// Public customer-facing site (Home + Menu)
import PublicHome from "@/pages/public/PublicHome";
import PublicMenu from "@/pages/public/PublicMenu";
import ReferralRedirect from "@/pages/public/ReferralRedirect";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<PublicHome />} />
        <Route path="/menu" element={<PublicMenu />} />
        <Route path="/r/:source" element={<ReferralRedirect />} />
        <Route path="/owner-cabinet/login" element={<Login />} />
        <Route path="/owner-cabinet" element={<Protected><AdminLayout /></Protected>}>
          <Route index element={<Products />} />
          <Route path="categories" element={<Categories />} />
          <Route path="media" element={<Media />} />
          <Route path="proof" element={<Proof />} />
          <Route path="homepage" element={<Homepage />} />
          <Route path="contact" element={<Contact />} />
          <Route path="inquiries" element={<Inquiries />} />
          <Route path="drops" element={<Drops />} />
          <Route path="referrals" element={<Referrals />} />
          <Route path="marketing" element={<Marketing />} />
          <Route path="settings" element={<Settings />} />
          <Route path="visual" element={<VisualEditor />} />
          <Route path="*" element={<Navigate to="/owner-cabinet" replace />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
